import moment from 'moment'

export const friendlyDateTime = dateTime => moment(dateTime).calendar()
export const formatTime = duration => moment(duration * 1000).format('mm:ss')



// WEBPACK FOOTER //
// ./src/utils/time.js